// extracted by mini-css-extract-plugin
export default {"iconColorWhite":"SidebarMenuItem_iconColorWhite__FFofQ","active":"SidebarMenuItem_active__jOLwN"};